<template>
    <div class="mainpage">
        <h2>transfers</h2>
        <ul class="menu">
            <li :class="{ active: tab==1 }" @click="setTab(1)" title="Transfer OUT">
                <factory-icon></factory-icon>
                <to-right-icon></to-right-icon>
            </li>
            <li :class="{ active: tab==2 }" @click="setTab(2)" title="On Transfer">
                <to-right-icon></to-right-icon>
                <transfer-icon></transfer-icon>
                <to-right-icon></to-right-icon>
            </li>
            <li :class="{ active: tab==3 }" @click="setTab(3)" title="Transfer IN">
                <to-right-icon></to-right-icon>
                <factory-icon></factory-icon>
            </li>
            <li :class="{ active: tab==4 }" @click="setTab(4)" title="List/Audit">
                <file-table></file-table>
            </li>
        </ul>
        <div class="home" v-if="tab==1">
            <TransferOUT></TransferOUT>
        </div>
        <div class="home" v-else-if="tab==2">
            2
        </div>
        <div class="home" v-else-if="tab==3">
            3
        </div>
        <div class="home" v-else-if="tab==4">
            4
        </div>
        <div class="home" v-else>
            <p class="c">choose a function in tabs above</p>
        </div>

        <div class="overlay" v-if="loading"></div>
        <div class="loading" v-if="loading">
            <sync-icon style="font-size: 80px; color: white"/>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import {mapState, mapGetters} from 'vuex'
    import RefreshIcon from "vue-material-design-icons/refresh"
    import DelIcon from "vue-material-design-icons/delete-circle"
    import SyncIcon from "vue-material-design-icons/sync"
    import TransferIcon from "vue-material-design-icons/truck"
    import FactoryIcon from "vue-material-design-icons/factory"
    import ToRightIcon from "vue-material-design-icons/chevron-double-right"
    import FileTable from "vue-material-design-icons/file-document"
    import TransferOUT from "@/components/TransferOUT"
    export default {
        name: "Transfers",
        components: {
            TransferOUT,
            RefreshIcon, DelIcon, SyncIcon, TransferIcon, FactoryIcon, ToRightIcon, FileTable
        },
        computed: {
            ...mapState(['loading', 'lastResult', 'transferOUT', 'lastConfirmedTransferOut']),
            okItemsCount: function () {
                return this.transferOUT.reduce((t, cv) => {
                    return (cv.icon == 1 ? (t + 1) : t)
                }, 0);
            }
        },
        data() {
            return {
                tmpSN: '',
                tab: 0,
                fromLocation: '',
                toLocation: '',
                comment: ''
            }
        },
        watch: {
            actField: function (f) {
                Vue.nextTick(() => {
                    if (this.$refs[f]) this.$refs[f].focus();
                });
            },
            lastResult: function () {
                this.$toasted.show(this.lastResult.msg, {
                    theme: "toasted-primary",
                    position: "top-center",
                    fullWidth: true,
                    duration: 3000,
                    type: this.lastResult.type
                });
            }
        },
        mounted() {
        },
        methods: {
            setTab(i) {
                this.tab = i;
            },
            scanSN() {
                if (this.tmpSN.trim().length < 6) return;
                this.$store.dispatch('checkSNforTrfOUT', {sn: this.tmpSN});
                this.tmpSN = '';
            },
            newOUT() {
                let validItems = this.transferOUT.filter(i => {
                    return (i.icon == 1);
                }).map(i => {
                    return parseInt(i.snID);
                });
                //console.log(validItems);
                this.$store.dispatch('makeTransferOUT', {sns: validItems});
            },
        }
    }
</script>

<style scoped>
    .f130 { font-size:  130% }
    .locationInfos {
        display: flex;
        flex:1 1 auto;
        align-content: stretch;
        justify-content: space-between;
    }
    .locationInfos INPUT {
        flex-grow: 1;
        margin: 10px;
        border: solid 1px #ccc;
        font-size: 20px;
        padding: 5px;
    }
    .comment {
        margin: 10px;
    }
    TEXTAREA {
        border: solid 1px #ccc;
        font-size: 15px;
        width: 100%;
    }
    .snlist {
        padding: 0;
        margin: 10px 0;
        list-style-type: none
    }

    .snlist LI {
        margin: 0px;
        padding: 2px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: solid 1px #ccc
    }

    .snlist .sn {
        flex: 1 1;
        padding-right: 4px
    }

    .snlist li:before {
        content: '?';
        padding: 1px 6px;
        color: white;
        background-color: deepskyblue;
        margin-right: 6px;
        border-radius: 4px;
    }

    .snlist li.ok:before {
        content: '✓';
        padding: 1px 5px;
        background-color: green;
    }

    .snlist li.notfound:before {
        content: '⨉';
        font-weight: bold;
        padding: 1px 6px;
        background-color: red;
        line-height: 17px;
    }

    .snlist li.dupl:before {
        content: '‼';
        font-weight: bold;
        padding: 1px 6px;
        background-color: orange;
    }

    .snlist li.ontrf:before {
        content: 'X';
        font-weight: bold;
        padding: 1px 6px;
        background-color: orange;
    }

    .menu {
        display: flex;
        justify-content: space-between;
        list-style-type: none;
        padding: 0;
        font-size: 25px;
        max-width: 900px;
        margin: 0 auto;

    }

    .menu LI {
        flex: 1 1;
        background-color: #666666;
        margin: 0 6px;
        text-align: center;
        color: white;
        padding: 5px 0;
        cursor: pointer;
        border-radius: 4px 4px 0 0;
    }

    .menu LI.active {
        background-color: green;
    }

    .status {
        border-left: solid 1px #999;
        padding: 0 2px;
        flex: 1 1;
        text-align: right;
        font-size: 11px;
    }

    @media (max-width: 400px) {
        .status {
            display: none;
        }
    }

    .form {
        display: flex;
        clear: both;
        align-items: center;
    }

    .form > DIV {
        white-space: nowrap;
        margin: 5px 7px 5px 0;
    }

    .btn2 {
        width: auto;
        margin: 10px auto;
        padding: 8px 20px;
        display: block;
    }
</style>